import { useHotkeys } from 'react-hotkeys-hook';

import { Hotkey } from 'config/enums';
import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import {
  handleResetCall,
  selectCanLeaveQueue,
} from 'features/call/call-base/store';
import { LeaveQueueCompletionBehavior } from 'features/leave-queue/enums';
import { resetCallComments } from 'features/call/vrs-call-comments/store';
import { leaveQueue } from 'features/leave-queue/store';

export const useLeaveQueue = () => {
  const dispatch = useAppDispatch();
  const canLeaveQueue = useAppSelector(selectCanLeaveQueue);

  const handleLeaveQueue = async () => {
    const { forcedLogoutStarted } = await dispatch(handleResetCall()).unwrap();
    dispatch(resetCallComments());

    if (forcedLogoutStarted) {
      return;
    }

    dispatch(
      leaveQueue({
        shouldFinishSession: true,
        completionBehavior: LeaveQueueCompletionBehavior.Reload,
      })
    );
  };

  useHotkeys(
    Hotkey.LeaveTheQueue,
    () => {
      void handleLeaveQueue();
    },
    { enabled: canLeaveQueue },
    [handleLeaveQueue]
  );

  return { handleLeaveQueue };
};
